const getAssetBaseUrl = () => (
  String(process.env.REACT_APP_API_BASE_URL || '')
    .replace(/\/api\/?$/i, '')
    .replace(/\/$/, '')
);

export const resolvePunditImageUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;

  const assetBaseUrl = getAssetBaseUrl();
  if (!assetBaseUrl) return url;

  const pathName = url.startsWith('/') ? url : `/${url}`;
  const publicPath = pathName.startsWith('/uploads/') ? `/api${pathName}` : pathName;

  return `${assetBaseUrl}${publicPath}`;
};

export const resolvePunditImageList = (urls = []) => (
  (Array.isArray(urls) ? urls : [])
    .map(resolvePunditImageUrl)
    .filter(Boolean)
);
